// Chilean phone utilities. Format: +56 + 9 digits (mobile: 9XXXXXXXX, landline: 2XXXXXXXX, etc).

export const CL_PREFIX = "+56";
export const WA_PREFIX = "+569"; // WhatsApp usa siempre móvil chileno

export function cleanPhoneDigits(value) {
  return (value || "").toString().replace(/\D/g, "");
}

export function normalizeClPhone(value) {
  // Keep prefix "+56" locked; strip non-digits and leading country code duplication.
  const digits = cleanPhoneDigits(value);
  const rest = digits.startsWith("56") ? digits.slice(2) : digits;
  return CL_PREFIX + rest.slice(0, 9);
}

export function isValidClPhone(value) {
  const digits = cleanPhoneDigits(value);
  const rest = digits.startsWith("56") ? digits.slice(2) : digits;
  // 9 digits after +56; first digit must be 2-9 (valid area / mobile codes).
  return rest.length === 9 && /^[2-9]/.test(rest);
}

export function normalizeClWhatsapp(value) {
  // Prefijo +569 fijo; solo acepta 8 dígitos del móvil.
  const digits = cleanPhoneDigits(value);
  let rest = digits.startsWith("56") ? digits.slice(2) : digits;
  if (rest.startsWith("9")) rest = rest.slice(1);
  return WA_PREFIX + rest.slice(0, 8);
}

export function isValidClWhatsapp(value) {
  const digits = cleanPhoneDigits(value);
  let rest = digits.startsWith("56") ? digits.slice(2) : digits;
  if (rest.startsWith("9")) rest = rest.slice(1);
  // 8 dígitos después de +569
  return rest.length === 8;
}
